import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import config from "../../../../config/config";
import moment from "moment";
import { snackActions } from '../../../sc-utilities/SnackBar';
import * as actionDownload from '../../../sc-downloadAll/store/downloadActions';
import { downloadFile } from '../../../sc-utilities';
import { socket } from '../../../../index';
import { download } from '../../../sc-utilities/download.utils';
import * as snackbarActions from '../../../sc-utilities/snackbar/store/snackbarActions';
import {STORAGE} from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";


// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/storageProduct',
    pluginName: 'PRODUCT',
    entityName: 'STORAGE_PRODUCT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    lazyLoad: true

});

export const downloadReport = (params) => {
    return async () => {
        const IDs = params.StorageProductIDs;
        const ErasureReportType = params.ErasureReportType;
        try {
            snackbarStore.dispatch(snackbarActions.showType({type: STORAGE, selectedNumber: IDs.length}));
            let token = localStorage.getItem('SESSION');

            for (const productID of params.StorageProductIDs) {

                const objectURL = `${config.backend_domain}:${config.backend_port}/report/download?ProductID=${productID}&ErasureReportType=${ErasureReportType}&ActiveCustomerID=${params.ActiveCustomerID}&Token=${token}`;

                let filename = `securaze_report.pdf`;

                let response = await fetch(objectURL, { method: 'GET', headers: { 'Content-Type': 'application/pdf' } });
                if (response.status === 200) {
                    const contentDisposition = response.headers.get('Content-Disposition').split(';');
                    for (const item of contentDisposition) {
                        if (item.includes('filename')) {
                            filename = item.split('=')[1];
                        }
                    }
                    let blob = await response.blob();

                    // Create blob link to download
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        filename,
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                } else {
                    snackActions.snackBar({
                        message: `File not found for one of selected files (${productID}).`,
                        options: {
                            variant: 'error'
                        }
                    });
                }
                snackbarStore.dispatch(snackbarActions.incrementCounter(STORAGE));
            }

        } catch (error) {
            console.log(error);
            snackActions.snackBar({
                message: `File not found.`,
                options: {
                    variant: 'error'
                }
            });
        }
        snackbarStore.dispatch(snackbarActions.resetSnackbarCounter(STORAGE))
    }
}
// Fetch storage only products action creators
export const fetchStorageProductInit = () => {
    return crudActions.fetchInit();
};
export const fetchStorageProductStart = () => {
    return crudActions.fetchStart();
};
export const fetchStorageProductSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchStorageProductFail = () => {
    return crudActions.fetchFail();
};
export const fetchStorageProduct = filter => {
    return async dispatch => {
        await crudActions.fetch(dispatch, filter);
    };
};
export const fetchStorageProductDataCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let countRes = await rest.post("/products/storageProduct/count", filterData);
            if (countRes.data && countRes.data.succeeded) {

                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch storage product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch storage product."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchStorageProductData = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let listRes = await rest.post("/products/storageProduct/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data.products
            }
            return []

        } catch (error) {
            return []

        }
    }
}

// Load storage product action creators
export const loadStorageProductInit = () => {
    return crudActions.loadInit();
};
export const loadStorageProductStart = () => {
    return crudActions.loadStart();
};
export const loadStorageProductSuccess = loadedStorageProduct => {
    return crudActions.loadSuccess(loadedStorageProduct);
};
export const loadStorageProductFail = error => {
    return crudActions.loadFail(error);
};
export const loadStorageProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadStorageProductStart());
        try {
            let res = await rest.post('products/storageProduct/load', params);
            if (res.data && res.data.succeeded) {
                dispatch(loadStorageProductSuccess(res.data.result.data ?? false));

                return res.data.result.data;
            }
            dispatch(loadStorageProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load storage product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load storage product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(loadStorageProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete storage products action creators
export const bulkDeleteStorageProductsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteStorageProductsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteStorageProductsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteStorageProductsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteStorageProducts = storageProducts => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, storageProducts);
    };
};

// Delete storage product action creators
export const deleteStorageProductInit = () => {
    return crudActions.deleteInit();
};
export const deleteStorageProductStart = () => {
    return crudActions.deleteStart();
};
export const deleteStorageProductSuccess = deletedStorageProduct => {
    return crudActions.deleteSuccess(deletedStorageProduct);
};
export const deleteStorageProductFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteStorageProduct = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};



// Edit storage product action creators
export const editStorageProductInit = () => {
    return crudActions.editInit();
};
export const editStorageProductStart = () => {
    return crudActions.editStart();
};
export const editStorageProductSuccess = editedStorageProduct => {
    return crudActions.editSuccess(editedStorageProduct);
};
export const editStorageProductFail = error => {
    return crudActions.editFail(error);
};
export const editStorageProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editStorageProductStart());
        try {
            let res = await rest.post('products/storageProduct/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated storage product.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editStorageProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit storage product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit storage product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editStorageProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// custom functions

export const generateReport = (storageProduct, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            storageProduct['SocketID'] = socket.id.split('#')[1];;
            dispatch({ type: 'START_GENERATE' });
            let res = await rest.post('report/generate', storageProduct);
            if (res.data && res.data.succeeded) {
                const redisTopic = res.data.result.data.RedisTopic;
                socket.once(redisTopic, async msg => {
                    const { Message, Status, ErasureReportID } = msg;
                    if (Status !== 'generated') {
                        snackActions.snackBar({
                            message: Message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                            options: {
                                variant: 'error'
                            }
                        });
                        dispatch({ type: 'FINISH_GENERATE' });
                        return false;
                    }
                    const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${storageProduct.ActiveCustomerID}`;
                    await download(objUrl);
                    snackActions.snackBar({
                        message: translations['generating_report'] || `Erasure report generation finished.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch({ type: 'FINISH_GENERATE' });

                });
            }
            else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list grade"}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const fetchGradingCategories = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/grading_category/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const gradingCategories = [];
                for (var category of res.data.result.data) {
                    gradingCategories.push({ value: category.GradingCategoryID, displayValue: category.Product });
                }
                return gradingCategories;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list grading category  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const fetchTypicalProblems = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/typical_problems/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                let typicalProblems = [];
                for (var tp of res.data.result.data) {
                    if (tp.GradingCategory && tp.GradingCategory.Product) {
                        tp.GradingCategory.Product = tp.GradingCategory.Product.replace('unknown', 'All');
                    }
                    typicalProblems.push({ value: tp.TypicalProblemID, label: `${tp.LongName}${tp.GradingCategory ? ` - ${tp.GradingCategory.Product}` : ''}` });
                }
                return typicalProblems;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list typical problems  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const downloadRawData = (ProductID, customerID) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/products/get_raw_data?ProductID=${ProductID}&ActiveCustomerID=${customerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            let fileName = `${moment().valueOf()}.txt`;
            response.headers.forEach((value, key) => {
                if (key === 'filename') {
                    fileName = value;
                }
            })
            if (response.status === 200) {
                return { status: 200, blob: await response.blob(), fileName: fileName }
            }
            try {
                let responseText = await response.text();
                responseText = JSON.parse(responseText);
                return {
                    status: response.status,
                    message: responseText.message
                }
            } catch (error) {
                return {
                    status: response.status,
                    message: null
                }
            }
        });
    }
};

export const fetchPrinters = (...id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/printers/list', { listAll: true });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list printers  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const printLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/storageProduct/print_label', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status === 200;

            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print label "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const fetchOrders = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('palettes/order/list', { listAll: true, formatForWEBUI: true, productChangePalette: true, ...id });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            if (response) {
                return response;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list orders"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const moveToAnotherPalette = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/storageProduct/change_palette', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;

            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot change palette "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}
export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}
export const bulkPrintLabels = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/storageProduct/bulk_print_label', data);

            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;

            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot prints labels  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const bulkGenerateReports = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            data['SocketID'] = socket.id.split('#')[1];;
            let res = await rest.post('products/storageProduct/bulk_generate_report', data);
            if (res.data.status === 200) {
                for (const redisTopic of res.data.result.data.RedisTopics) {
                    socket.once(`${redisTopic}|0`, () => {
                        snackActions.snackBar({
                            message: `Erasure report starting.`,
                            options: {
                                variant: 'info'
                            }
                        });

                        socket.once(`${redisTopic}|2`, async msg => {
                            if (msg.Message.name === 'ERROR') {
                                snackActions.snackBar({
                                    message: `Error: Report failed. Please contact administrator.`,
                                    options: {
                                        variant: 'error'
                                    }
                                });
                                return false;
                            }
                            const reportID = msg.Message.data;
                            const filename = msg.Message.name;

                            let file = await dispatch(actionDownload.downloadErasure(reportID, data.ActiveCustomerID, filename));
                            if (file) {
                                downloadFile(file, filename);
                            }
                        });
                    });
                }
                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot generate report"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            return false;
        }
    }
}


export const unpairExternal = externalID => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/storageProduct/unpair', { ProductExternalInfoID: externalID });
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status === 200;

            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot unpair external  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}
export const unpairBulkExternalStorage = externalIDs => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/storageProduct/bulk_unpair', { ProductExternalInfoIDs: externalIDs.data, ActiveCustomerID: externalIDs.ActiveCustomerID });
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status === 200;

            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot unpair externals"}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}
export const productStorageImageStart = () => {
    return {
        type: "PRODUCT_STORAGE_IMAGE_START",
        loading: true
    };
};
export const productStorageImageSuccess = (img) => {
    return {
        type: "PRODUCT_STORAGE_IMAGE_SUCCESS",
        image: img,
    };
};
export const productStorageImageFail = () => {
    return {
        type: "PRODUCT_STORAGE_IMAGE_FAIL",
        loading: false
    };
};


export const imagesList = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(productStorageImageStart())

            let res = await rest.post(`/upload/photos`, data);
            if (res.data.status === 200) {
                dispatch(productStorageImageSuccess(res.data.result))

                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result;

            }
            else {
                dispatch(productStorageImageFail());

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list image "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }

        } catch (error) {
            dispatch(productStorageImageFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const galleryTrue = () => {
    return ({
        type: 'GALLERY_OPEN_STORAGE_PRODUCT',
    });
}
